import { Box, Button, Container, Grid, Typography } from "@mui/material";
import ChangePass from "../components/ChangePassword";
export default function ChangePassword() {
  return (
    <Box
      className="index"
      sx={{
        position: "fixed",
        zIndex: 4,
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        background: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Container sx={{ display: "flex", flexDirection: "column", alignItems: "center" }} maxWidth="lg">
        <ChangePass />
      </Container>
    </Box>
  );
}
